/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Wiz_Home_QInputs */



/**
* | output |
* | --- |
* | "Where do the games happen?" |
*
* @param {Tournament_Wiz_Home_QInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_wiz_home_q = /** @type {((inputs?: Tournament_Wiz_Home_QInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Wiz_Home_QInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Où se déroulent les parties ?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Dónde se juegan las partidas?")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Onde acontecem as partidas?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Dove si svolgono le partite?")
	return /** @type {LocalizedString} */ ("Where do the games happen?")
});